import { CheckboxItem } from "sv-chemistry-ng-lib";

export interface Order {
  selectionCheckbox? : CheckboxItem;
  fileName : string;
  createDate : Date;
  transmissionDate : Date;
  deliveryDate : Date;
  downloaded : boolean;
  orderId : number;
}

export class PageOrder {
  selectionCheckbox? : CheckboxItem = new CheckboxItem(true);
  fileName : string;
  createDate : Date;
  transmissionDate : Date;
  deliveryDate : Date;
  downloaded : boolean;
  orderId : number;

  get status() : string {
    return (this.downloaded ? "Downloaded" : "Ready to Download");
  }
}